// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/payments/salary-advances/requests",
  Create: "/pyr/payments/salary-advances/requests",
  Update: "/pyr/payments/salary-advances/requests",
  Detail: "/pyr/payments/salary-advances/requests",
  Approve: "/pyr/payments/salary-advances/requests/approve",
};
